import React, { forwardRef, useCallback } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface TimelineColumn {
  date: Date;
  label: string;
  fullLabel: string;
  type: 'day' | 'week' | 'month';
}

interface GanttTimelineProps {
  columns: TimelineColumn[];
  columnWidth: number;
  viewMode: 'monthly' | 'weekly' | 'daily';
  onScroll?: (scrollLeft: number) => void;
}

export const GanttTimeline = forwardRef<HTMLDivElement, GanttTimelineProps>(
  ({ columns, columnWidth, viewMode, onScroll }, ref) => {
    const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
      onScroll?.(e.currentTarget.scrollLeft);
    }, [onScroll]);

    return (
      <div className="border-b border-border pb-2 sticky top-0 bg-background z-10">
        <div className="flex">
          <div className="w-64 font-medium text-sm text-muted-foreground flex-shrink-0">
            Appel d'offres
          </div>
          <div 
            ref={ref}
            className="flex-1 overflow-x-auto scrollbar-thin"
            onScroll={handleScroll}
          >
            <div 
              className="flex" 
              style={{ width: columns.length * columnWidth }}
            >
              {columns.map((column, index) => (
                <div 
                  key={index} 
                  className="text-center py-1 border-r border-border/50 last:border-r-0 flex-shrink-0"
                  style={{ width: columnWidth }}
                >
                  <div className="font-medium text-xs">{column.label}</div>
                  {viewMode === 'daily' && (
                    <div className="text-xs text-muted-foreground/70">
                      {format(column.date, 'EEE', { locale: fr })}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

GanttTimeline.displayName = 'GanttTimeline';